import Model from './Model'

class Attachment extends Model {
  constructor (initialData) {
    super(initialData, {
      momentKeys: [
        'created_at',
        'updated_at',
      ],
    })

    // console.log(`Attachment ${this.id}`, this)
  }
}

export default Attachment
